import { useAuth } from './use-auth';
import { User, Role } from '@/lib/types';

export default function useCurrentUser() {
  const auth = useAuth();
  return {
    user: auth.user as User & { role: Role },
  };
}
